import React from 'react';

export const TypeArray: React.FC = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.90625 8.04565C5.90625 8.0284 5.89226 8.0144 5.875 8.0144C5.85774 8.0144 5.84375 8.0284 5.84375 8.04565C5.84375 8.06291 5.85774 8.0769 5.875 8.0769C5.89226 8.0769 5.90625 8.06291 5.90625 8.04565"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.03125 8.04565C8.03125 8.0284 8.01726 8.0144 8 8.0144C7.98274 8.0144 7.96875 8.0284 7.96875 8.04565C7.96875 8.06291 7.98274 8.0769 8 8.0769C8.01726 8.0769 8.03125 8.06291 8.03125 8.04565"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.1562 8.04565C10.1562 8.0284 10.1423 8.0144 10.125 8.0144C10.1077 8.0144 10.0937 8.0284 10.0937 8.04565C10.0937 8.06291 10.1077 8.0769 10.125 8.0769C10.1423 8.0769 10.1562 8.06291 10.1562 8.04565"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.81781 13.5V2.5H5.62632V3.33085H3.74228V12.6691H5.62632V13.5H2.81781Z"
      fill="currentColor"
    />
    <path
      d="M13.1822 13.5V2.5H10.3737V3.33085H12.2577V12.6691H10.3737V13.5H13.1822Z"
      fill="currentColor"
    />
  </svg>
);
